export default __webpack_public_path__ + "static/media/icon-green-check.5c21e958.webp";